import Container from '@/components/@base/container';
import CheckBox from '@/components/@base/input/check-box';
import { SegmentProps } from '@/components/wallets-section/types';
import { Text } from '@/components/@base/typography';
import localization from '@/constant/localization';
import Button from '@/components/@base/button';
import useBottomSheetStore from '@/store/bottom-sheet-store';
import EditWallet from '@/components/edit-wallet';
import { getFromSessionStorage, isDesktop } from '@/lib/helper';
import cn from '@/lib/clsxm';
import useUserWalletsVouchersStore from '@/store/user-wallets-store';
import useHomeStore from '@/store/home';
import useCommonModalStore from '@/store/common-modal-store';
import { usePostValidateSelections } from '@/services/hooks';
import { selectedSegments, selectedVouchers } from '@/services/models/api.models';
import mockWalletLogo from '@/assets/mock-items/default-segment-icon.svg';
import { useNavigate, useSearchParams } from 'react-router-dom';
import FontIcon from '@/components/@base/font-icon';
import { useState } from 'react';

const WalletListItem = ({
  data,
  unUsable,
  disable = '',
  noBorderBottom,
  className,
  hasOzoneCard
}: {
  data: SegmentProps;
  unUsable?: boolean;
  disable?: string;
  noBorderBottom?: boolean;
  hasOzoneCard?: boolean;
  className?: string;
}) => {
  const {
    balance,
    segmentId,
    expirationDateTime,
    segmentTypeId,
    upgTitle,
    segmentAdditionalInfo,
    upgLogo,
    cardNumber,
    selected,
    usageBalance,
    unEditable,
    isEdited,
    isDisable,
  } = data;
  const { setShowBottomSheet } = useBottomSheetStore();
  const { setSegments, segments, usableClientVouchers } = useUserWalletsVouchersStore();
  const { setShow } = useCommonModalStore();
  const { remainInvoice, isActiveRequest, setIsActiveRequest } = useHomeStore();
  const { mutate: mutateValidation, isPending: pendingValidation } =
    usePostValidateSelections();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [isWalletSelected, setIsWalletSelected] = useState(false);
  const handleSatPayOtp = (e: any) => {
    e.stopPropagation();
    // <WalletOtp data={data}/>
  };

  const handleClickOnWallet = () => {
    setIsWalletSelected(true);
    setTimeout(() => setIsWalletSelected(false), 400);
    sessionStorage.setItem('isSelectedVoucherOrWallet', 'true');
    const selectedSegments: selectedSegments[] = [];
    segments?.map((s) => {
      if (s.selected) {
        selectedSegments.push({
          segmentId: s.segmentId,
          amount: s.usageBalance!,
        });
      }
    });
    const selectedVouchers: selectedVouchers[] = [];
    usableClientVouchers?.map((s) => {
      if (s.selected) {
        selectedVouchers.push({
          voucherId: s.voucherId,
        });
      }
    });
    if (isDisable) {
      mutateValidation(
        {
          selectedSegments: selectedSegments,
          lastSelectedSegment: {
            segmentId: data.segmentId,
            amount: data.balance >= remainInvoice ? remainInvoice : data.balance,
          },
          notSelectedSegments: segments
            .filter((i) => i.segmentId !== data.segmentId)
            .filter((i) => !i.selected),
          lastSelectedVoucher: {},
          selectedVouchers: selectedVouchers,
          notSelectedVouchers: usableClientVouchers.filter((i) => !i.selected),
        },
        {
          onSuccess: (res) => {
            if (res?.responseCode === 0) {
              setShow(true, {
                center: true,
                dialogPanelClassName: 'p-0 w-[90%] md:w-[380px]',
                Body: () => (
                  <Container center className='flex-col px-4 pb-4 pt-6'>
                    <img
                      src={data.upgLogo}
                      alt={data.upgTitle}
                      className={cn('w-15 mb-4 h-10 rounded')}
                    />
                    <Text
                      className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0'
                      semiBold
                    >
                      {data.upgTitle}{segmentAdditionalInfo && ` (${segmentAdditionalInfo})`}
                    </Text>
                    <Text className='mt-2 px-4 text-center text-[15px] leading-7 text-grayLight-850 dark:text-grayDark-300'>
                      {localization.assetCantSpendable(data.upgTitle)}
                    </Text>
                    <Container className='my-4 w-full rounded-xl bg-grayLight-50 px-3 py-3 dark:bg-grayLight-850'>
                      {res?.lastSelectedAssetNotSpendableWithSelectedSegments?.map((s) => (
                        <Text className='flex items-center gap-1.5 text-grayLight-850 dark:text-grayDark-300'>
                          <span className='block h-1.5 w-1.5 rounded-full bg-grayLight-850 dark:bg-grayDark-300' />
                          {s.upgTitle}
                        </Text>
                      ))}
                      {res?.lastSelectedAssetNotSpendableWithSelectedVouchers?.map((v) => (
                        <Text className='flex items-center gap-1.5 text-grayLight-850 dark:text-grayDark-300'>
                          <span className='block h-1.5 w-1.5 rounded-full bg-grayLight-850 dark:bg-grayDark-300' />
                          {v.voucherRuleTypeTitle}
                        </Text>
                      ))}
                    </Container>
                    <Button
                      className='text-md h-12 w-full rounded-full'
                      onClick={() => setShow(false)}
                    >
                      {localization.iGetIt}
                    </Button>
                  </Container>
                ),
              });
            }
            setIsActiveRequest(false);
          },
          onError: () => {
            setIsActiveRequest(false);
          },
        },
      );
    } else if (!unUsable && !isActiveRequest) {
      setIsActiveRequest(true);
      const updatedSegments: SegmentProps[] = [];
      if (remainInvoice > 0 && !data.selected && !pendingValidation) {
        mutateValidation(
          {
            selectedSegments: selectedSegments,
            lastSelectedSegment: {
              segmentId: data.segmentId,
              amount: data.balance >= remainInvoice ? remainInvoice : data.balance,
            },
            notSelectedSegments: segments
              .filter((i) => i.segmentId !== data.segmentId)
              .filter((i) => !i.selected),
            lastSelectedVoucher: {},
            selectedVouchers: selectedVouchers,
            notSelectedVouchers: usableClientVouchers.filter((i) => !i.selected),
          },
          {
            onSuccess: (res) => {
              if (res?.responseCode === 0) {
                segments?.map((s) => {
                  if (s.segmentId === data.segmentId) {
                    s.selected = true;
                    s.usageBalance = s.balance >= remainInvoice ? remainInvoice : s.balance;
                  }
                  res.notSelectedSegmentsNotSpendable.map((ns) => {
                    if (s.segmentId === ns.segmentId) {
                      s.isDisable = true;
                    }
                  });
                  updatedSegments.push(s);
                });
                usableClientVouchers?.map((v) => {
                  res.notSelectedVouchersNotSpendable.map((ns) => {
                    if (v.voucherId === ns.voucherId) {
                      v.isDisable = true;
                    }
                  });
                });
                setSegments(updatedSegments);
              }
              // else if (res?.responseCode === 10 || res?.responseCode === 15) {
              //   setChooseValidate(res);
              //   setShowBottomSheet(true, {
              //     Body: () => <AcceptSelection />
              //   });
              // }
              setIsActiveRequest(false);
            },
            onError: () => {
              setIsActiveRequest(false);
            },
          },
        );
      } else if (
        (remainInvoice > 0 || data.selected) &&
        !pendingValidation &&
        !isActiveRequest
      ) {
        mutateValidation(
          {
            selectedSegments: selectedSegments.filter((s) => s.segmentId !== data.segmentId),
            lastSelectedSegment: {},
            notSelectedSegments: segments
              .filter((i) => i.segmentId !== data.segmentId)
              .filter((i) => !i.selected),
            lastSelectedVoucher: {},
            selectedVouchers: selectedVouchers,
            notSelectedVouchers: usableClientVouchers.filter((i) => !i.selected),
          },
          {
            onSuccess: (res) => {
              if (res?.responseCode === 0) {
                segments?.map((s) => {
                  if (s.segmentId === data.segmentId) {
                    if (data.selected) {
                      s.selected = !s.selected;
                      s.usageBalance = 0;
                      s.isEdited = false;
                    }
                  } else s.isDisable = false;
                  res.notSelectedSegmentsNotSpendable.map((ns) => {
                    if (s.segmentId === ns.segmentId) {
                      s.isDisable = true;
                    }
                  });
                  updatedSegments.push(s);
                });
                usableClientVouchers?.map((v) => {
                  v.isDisable = false;
                  res.notSelectedVouchersNotSpendable.map((ns) => {
                    if (v.voucherId === ns.voucherId) {
                      v.isDisable = true;
                    }
                  });
                });
                setSegments(updatedSegments);
              }
              // else if (res?.responseCode === 10 || res?.responseCode === 15) {
              //   setChooseValidate(res);
              //   setShowBottomSheet(true, {
              //     Body: () => <AcceptSelection />
              //   });
              // }
              setIsActiveRequest(false);
            },
            onError: () => {
              setIsActiveRequest(false);
            },
          },
        );
      } else if (remainInvoice === 0) {
        invoiceRemainIsZero();
        setIsActiveRequest(false);
      }
    }
  };
  const handleEditWallet = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => {
    !isDisable && e.stopPropagation();
    if (!isDisable) {
      if (remainInvoice !== 0 || data.selected) {
        isDesktop()
          ? setShow(true, {
              // bgLighter: type !== 'satpay',
              Body: () => (
                <EditWallet data={data} handleClickOnWallet={() => handleClickOnWallet()} />
              ),
            })
          : setShowBottomSheet(true, {
              // bgLighter: type !== 'satpay',
              bgLighter: true,
              Body: () => (
                <EditWallet data={data} handleClickOnWallet={() => handleClickOnWallet()} />
              ),
            });
      } else if (remainInvoice === 0) {
        invoiceRemainIsZero();
      }
    }
  };

  const invoiceRemainIsZero = () => {
    navigate(`/?pgc=${searchParams.get('pgc')}&mt=invoice-remain-is-zero`);
    const closeModal = () => {
      setShow(false);
      navigate(`/?pgc=${searchParams.get('pgc')}`);
    };
    setShow(true, {
      center: true,
      dialogPanelClassName: 'p-0 w-[90%] md:w-[380px]',
      Body: () => (
        <Container center className='flex-col pt-6'>
          <Container center className='mb-6 h-[56px] w-[56px] rounded-full bg-green-50'>
            <FontIcon icon='icon-check' className='text-3xl text-green' />
          </Container>

          <Text className='mb-2 text-xl text-grayLight-1000 dark:text-grayLight-0' semiBold>
            {localization.zeroAmount}
          </Text>
          <Text className='mb-6 mt-2 px-4 text-center text-[15px] leading-7 text-grayLight-850 dark:text-grayDark-300'>
            {localization.zeroAmountCaption}
          </Text>
          <Container className='w-full p-4'>
            <Button className='text-md h-12 w-full rounded-full' onClick={closeModal}>
              {localization.iGetIt}
            </Button>
          </Container>
        </Container>
      ),
    });
  };

  return (
    <>
      <Container
        center
        className={cn(
          'z-1 relative min-h-[88px] w-full border-b-2 border-grayLight-0 bg-grayLight-50 pl-4 last:border-none last:custom-last dark:border-grayLight-990 dark:bg-grayDark-750',
          className,
          (!unUsable || !isDisable) && 'cursor-pointer',
          unUsable && 'rounded-xl',
          isWalletSelected && 'blink-500',
          // hasOzoneCard && 'items-start py-2 pt-4',
        )}
        onClick={() => handleClickOnWallet()}
      >
        {pendingValidation && <Container className='state-changed z-10' />}
        {/*{isDisable && <Container className='gray-overlay z-20' />}*/}
        {upgLogo && upgLogo?.length > 0 && (
          <img
            src={upgLogo}
            alt=''
            className={cn(
              'w-15 ml-3 mr-3 h-10 rounded md:mr-6',
              (!!disable || isDisable) && 'opacity-50 grayscale',
              // hasOzoneCard && 'mt-1',
            )}
          />
        )}
        {(!upgLogo || upgLogo?.length === 0) && (
          <img
            src={mockWalletLogo}
            alt=''
            className={cn(
              'w-15 ml-3 mr-3 h-10 rounded md:mr-6',
              (!!disable || isDisable) && 'opacity-50 grayscale',
            )}
          />
        )}
        <Container
          center
          className={cn(
            'h-full min-h-[88px] w-full justify-between py-4',
            noBorderBottom && 'border-none',
            // hasOzoneCard && 'items-start py-0',

          )}
        >
          <Container className='flex flex-col gap-1'>
            <Text
              className={cn(
                'text-sm font-medium text-grayLight-1000 dark:text-grayLight-0',
                unUsable && 'font-normal text-grayLight-650',
                isDisable && '!text-grayLight-650',
              )}
            >
              {upgTitle}
            </Text>
            {segmentAdditionalInfo && (
              <Text
                className={cn(
                  'text-sm text-grayLight-600 dark:text-grayDark-75',
                  isDisable && '!text-grayLight-650',
                )}
              >
                {segmentAdditionalInfo}
              </Text>
            )}
            {unUsable && (
              <Container
                center
                className='mt-2 w-fit gap-1 rounded-md border border-yellow-500 bg-yellow-50 px-2 py-0 dark:bg-yellow-900'
              >
                <Text className='text-yellow-500 dark:text-yellow-300'>{disable}</Text>
                <FontIcon
                  icon='icon-circle-information'
                  className='text-yellow-500 dark:text-yellow-300'
                />
              </Container>
            )}
            {!unUsable && (
              <Text
                className={cn(
                  'text-sm text-grayLight-600 dark:text-grayDark-75',
                  selected && !isEdited && 'text-blue dark:text-blue-200',
                  isDisable && '!text-grayLight-650',
                )}
              >
                {localization.walletPayableAmount(balance?.toLocaleString())}
              </Text>
            )}
            {isEdited && !unUsable && usageBalance! > 0 && (
              <Text className='text-sm text-blue dark:text-blue-200'>
                {localization.walletInvoicePayableAmount(usageBalance?.toLocaleString()!)}
              </Text>
            )}
            {/*{hasOzoneCard && (*/}
            {/*  <Container*/}
            {/*    center*/}
            {/*    className={cn(*/}
            {/*      'w-[calc(100%+25px)] justify-start gap-2.5 overflow-hidden rounded-2xl border border-white/40 bg-white/40 px-2.5 py-1 shadow-sm backdrop-blur-lg xl:w-[calc(100%+68px)] dark:border-white/10 dark:bg-black/20',*/}
            {/*      getFromSessionStorage('editableWallets') && "w-[calc(100%+60px)]")}*/}
            {/*  >*/}
            {/*    <Container className='glass-green-overlay z-[9]' />*/}
            {/*    <div className='relative flex h-3 w-3 items-center justify-center'>*/}
            {/*      <span*/}
            {/*        className='rounded-full bg-[#00CC63]'*/}
            {/*        style={{*/}
            {/*          animation: 'ozone-green-dot 1200ms ease-in-out infinite',*/}
            {/*        }}*/}
            {/*      />*/}
            {/*    </div>*/}
            {/*    <Text className='text-xs text-black dark:text-white'>*/}
            {/*      {localization.discountWithOzone}*/}
            {/*    </Text>*/}
            {/*  </Container>*/}
            {/*)}*/}
            {/*{ !unUsable && && type === 'satpay' &&*/}
            {/*  <Button variant={VARIANT_ENUM.TEXT} className='text-xs text-primary dark:text-primary-300 px-1 h-5 hover:bg-transparent' onClick={(e) => handleSatPayOtp(e)}>{localization.clickForAmount}</Button>}*/}
          </Container>

          {/*{unUsable && (*/}
          {/*  <Text className='pl-4 text-sm text-grayLight-1000 dark:text-grayLight-0'>*/}
          {/*    {rialPostFix(balance)}*/}
          {/*  </Text>*/}
          {/*)}*/}
          <Container center>
            {isDisable && (
              <FontIcon
                icon='icon-circle-information'
                className='ml-[20px] text-xl text-grayLight-25 dark:text-grayLight-750'
              />
            )}
            {!unUsable && <CheckBox checked={selected} isDisable={isDisable} />}
            {getFromSessionStorage('editableWallets') && !unUsable && !unEditable && (
              <Container
                center
                className='mr-[10px] h-10 w-10'
                onClick={(e) => handleEditWallet(e)}
              >
                <FontIcon
                  icon='icon-chevron-down'
                  className={cn(
                    'text-2xl text-black dark:text-white',
                    isDisable && 'text-grayLight-25 dark:text-grayLight-750',
                  )}
                />
              </Container>
            )}
          </Container>
        </Container>
      </Container>
    </>
  );
};

export default WalletListItem;
